import { FormGroup, AbstractControl } from '@angular/forms';
import { PatientEditInfo } from '../../model/patient/patient-edit-info';
import { setValidControl, setInValidControl } from '../validaror-invalid-control';
import { PatientView } from 'src/app/model/patient';
import { DocumentTypeEnum } from 'src/app/model/patient/document-type-enum';


export function patientValidator(control: FormGroup) {

    if (control.value) {
        let valid  = control.valid;
        const patient = <PatientEditInfo>control.getRawValue();


        if (patient.DocumentType.Id != DocumentTypeEnum.SinDocumento && !patient.Number) {
            control.controls['Number'].setErrors({ 'invalidNumber': true });
            valid = false;
        }

        if ( !patient.PersonalPhone && !patient.CellPhone && !patient.LaborPhone ) {
            control.controls['PersonalPhone'].setErrors({ 'invalidOnePhoneRequired': true });
            control.controls['LaborPhone'].setErrors({ 'invalidOnePhoneRequired': true });
            control.controls['CellPhone'].setErrors({ 'invalidOnePhoneRequired': true });
            valid = false;
        }

        if ( control.controls['IsReceptionSector'].value && patient.InAutoGestion &&  patient.ViewResultWeb == null ) {
            control.controls['ViewResultWeb'].setErrors({ 'invalidViewResultWeb': true });
            valid = false;
        }

        if (valid) {
            setValidControl(control.controls['ViewResultWeb']);
            setValidControl(control.controls['PersonalPhone']);
            setValidControl(control.controls['LaborPhone']);
            if (control.controls['CellPhone'].errors) {
                if (!control.controls['CellPhone'].errors.invalidCellPhoneNumber) {
                    setValidControl(control.controls['CellPhone']);
                }
            }
            return null;
        } else {
            return  { 'invalidPatient': true };
        }
    } else {
        return null;
    }
}

export function patientViewValidator(control: AbstractControl) {

   if (control.value != null) {
        const patienteView = <PatientView>control.value;

        if ( patienteView.InAutoGestion && patienteView.ViewResultWeb == null ) {
            return  { 'invalidPatientViewResultWeb': true };
        } else {
            return null;
        }
    } else {
        return null;
    }
}

